import React, { useState, useContext, useEffect } from 'react';
import { Box, Typography, Avatar, IconButton, Button, useMediaQuery } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import DeleteOutlineIcon from '@mui/icons-material/DeleteOutline';
import SaveIcon from '@mui/icons-material/Save';
import RestaurantIcon from '@mui/icons-material/Restaurant';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import Dialog from '@mui/material/Dialog';
import MealOrderOptionsMenu from './MealOrderOptionsMenu';
import { OrdersContext } from '../../../lib/contexts/OrdersContext';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import QuantityAdjuster from './subComponents/QuantityAdjuster';
import Drawer from '@mui/material/Drawer';
import MealInfoCard from './MealInfoCard';
import { BenefitDetailsContext } from '../../../lib/contexts/BenefitDetailsContext';
import { findBenefitByID } from '../../../lib/contexts/BenefitDetailsContext';

const OrderDetailsAdjustmentCard = ({ order, onClose }) => {
  const {
    state: { ordersMetrics },
    actions: { updateOrderMeals },
  } = useContext(OrdersContext);
  const [meals, setMeals] = useState(order.order_items || []);
  const [hasChanges, setHasChanges] = useState(false);
  const [showMealOptions, setShowMealOptions] = useState(false);
  const isMobileView = useMediaQuery('(max-width: 600px)');
  const [selectedMeal, setSelectedMeal] = useState(null);
  const { benefitDetails } = useContext(BenefitDetailsContext);
  const [maxQuantity, setMaxQuantity] = useState(14);

  useEffect(() => {
    setMaxQuantity(ordersMetrics[order.id]?.totalItemsNeeded);
  }, [ordersMetrics]);

  const handleQuantityChange = (id, newQuantity) => {
    const updatedMeals = meals.map((meal) => (meal.box_id === id ? { ...meal, quantity: newQuantity } : meal));
    setMeals(updatedMeals);
    setHasChanges(true);
  };

  const handleDelete = (id) => {
    const updatedMeals = meals.filter((meal) => meal.box_id !== id);
    setMeals(updatedMeals);
    setHasChanges(true);
  };

  const handleAddMeal = (newMeals) => {
    // console.log('here is the newMeals in handleAddMeal: ', newMeals);
    const updatedMeals = [...meals];

    newMeals.forEach((newMeal) => {
      const existingMeal = updatedMeals.find((meal) => meal.box_id === newMeal.box_id);
      if (existingMeal) {
        existingMeal.quantity += 1;
      } else {
        updatedMeals.push({ ...newMeal, quantity: 1 });
      }
    });

    setMeals(updatedMeals);
    setHasChanges(true);
  };

  // useEffect(() => {
  //     console.log('here is the meals array in useEffect in OrderDetailsAdjustmentCard: ', meals);
  // }, [meals]);

  const handleSave = () => {
    updateOrderMeals(order.id, meals)
      .then(() => {
        setHasChanges(false);
        onClose();
      })
      .catch((error) => {
        console.error('Error updating order:', error);
      });
  };

  const handleDecrement = (id) => {
    const updatedMeals = meals.map((meal) =>
      meal.box_id === id ? { ...meal, quantity: Math.max(meal.quantity - 1, 0) } : meal,
    );
    setMeals(updatedMeals);
    setHasChanges(true);
  };

  const handleIncrement = (id) => {
    const updatedMeals = meals.map((meal) => (meal.box_id === id ? { ...meal, quantity: meal.quantity + 1 } : meal));
    setMeals(updatedMeals);
    setHasChanges(true);
  };

  const totalMeals = meals.reduce((acc, meal) => acc + meal.quantity, 0);
  const isTotalValid = totalMeals === maxQuantity;

  const handleMealClick = (meal) => {
    setSelectedMeal(meal);
  };

  const closeMealInfoCard = () => {
    setSelectedMeal(null);
  };
  // console.log('here is the selectedMeal in OrderDetailsAdjustmentCard: ', selectedMeal);
  return (
    <Box
      id="adjustment-card-container"
      sx={{
        display: 'flex',
        // width: '382px',
        width: '100%',
        padding: '16px 24px',
        flexDirection: 'column',
        justifyContent: 'center',
        alignItems: 'center',
        gap: '24px',
        borderRadius: '8px',
        // border: '2px solid var(--color3, #F5F4F9)',
        // background: 'var(--Gray-gray2, #F8F8F8)',
        position: 'sticky',
        top: '0',
      }}
    >
      <Box
        id="adjustment-card-main-container"
        sx={{
          display: 'flex',
          flexDirection: 'column',
          alignItems: 'flex-start',
          gap: '12px',
          alignSelf: 'stretch',
          borderRadius: '8px',
        }}
      >
        <Box
          id="header"
          sx={{
            display: 'flex',
            padding: '6px 0px',
            alignItems: 'center',
            gap: '8px',
            alignSelf: 'stretch',
          }}
        >
          <ArrowBackIcon
            onClick={onClose}
            sx={{
              cursor: 'pointer',
              height: '24px',
              width: '24px',
            }}
          />
          <Box
            id="title-and-info"
            sx={{
              display: 'flex',
              alignItems: 'center',
              gap: '12px',
              flex: '1 0 0',
            }}
          >
            <Typography
              sx={{
                color: 'var(--Gray-gray12, #171717)',
                fontFamily: 'Montserrat',
                fontSize: '20px',
                fontStyle: 'normal',
                fontWeight: 700,
                lineHeight: '125%',
              }}
            >
              Edit Order Items
            </Typography>
            {/* <ErrorOutlineIcon
                            sx={{
                                width: 'var(--1-5, 24px)',
                                height: '24px',
                            }}
                        /> */}
          </Box>
          <Typography
            sx={{
              color: totalMeals !== maxQuantity ? '#DF230A' : 'var(--Gray-gray12, #171717)',
              textAlign: 'right',
              leadingTrim: 'both',
              textEdge: 'cap',
              fontFamily: 'Montserrat',
              fontSize: '20px',
              fontStyle: 'normal',
              fontWeight: 700,
              lineHeight: 'normal',
            }}
          >
            {`${totalMeals}/${maxQuantity}`}
          </Typography>
        </Box>
        {totalMeals !== maxQuantity && (
          <Box
            id="warning-box"
            sx={{
              display: 'flex',
              padding: '12px 0px',
              justifyContent: 'center',
              alignItems: 'center',
              gap: '10px',
              alignSelf: 'stretch',
              borderRadius: '12px',
              border: '1px solid var(--_Tamagui-Red-red11, #CD2B31)',
              background: 'var(--_Tamagui-Red-red4, #FFE5E5)',
            }}
          >
            <ErrorOutlineIcon
              sx={{
                width: 'var(--1-5, 24px)',
                height: 'var(--1-5, 24px)',
              }}
            />
            <Typography
              sx={{
                color: 'var(--Gray-gray12, #171717)',
                leadingTrim: 'both',
                textEdge: 'cap',
                fontFamily: 'Montserrat',
                fontSize: '14px',
                fontStyle: 'normal',
                fontWeight: 400,
                lineHeight: 'normal',
              }}
            >
              Total order items must equal:{' '}
              <span
                style={{
                  color: 'var(--Gray-gray12, #171717)',
                  leadingTrim: 'both',
                  textEdge: 'cap',
                  fontFamily: 'Montserrat',
                  fontSize: '14px',
                  fontStyle: 'normal',
                  fontWeight: 700,
                  lineHeight: 'normal',
                }}
              >
                {maxQuantity}
              </span>
            </Typography>
          </Box>
        )}
        <Box
          id="body"
          sx={{
            display: 'flex',
            padding: '0px 16px',
            flexDirection: 'column',
            alignItems: 'flex-start',
            gap: '24px',
            alignSelf: 'stretch',
          }}
        >
          {meals.map((meal, index) => (
            <Box
              key={meal.box_id}
              id="meal-item"
              sx={{
                display: 'flex',
                // flexDirection: 'row',
                alignItems: 'center',
                gap: '12px',
                width: '100%',
                borderRadius: '8px',
              }}
            >
              <Box
                id="meal-image"
                sx={{
                  width: '64px',
                  height: '64px',
                  borderRadius: '64px',
                  background: `url(${meal.box_image}) lightgray 50% / cover no-repeat`,
                  boxShadow:
                    '1px 2px 3px 0px rgba(0, 0, 0, 0.17), 0px 1px 10px 0px rgba(0, 0, 0, 0.02), 0px 2px 4px -1px rgba(17, 17, 17, 0.03)',
                }}
                onClick={() => handleMealClick(meal)}
              />
              <Box
                id="item-details"
                sx={{
                  display: 'flex',
                  flexDirection: 'column',
                  justifyContent: 'center',
                  alignItems: 'flex-start',
                  gap: '4px',
                  flex: '1 0 0',
                  alignSelf: 'stretch',
                }}
              >
                <Box
                  id="item-header"
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    alignSelf: 'stretch',
                  }}
                >
                  <Box
                    id="meal-name-container"
                    sx={{
                      display: 'flex',
                      flexDirection: 'column',
                      justifyContent: 'center',
                      alignItems: 'flex-start',
                      gap: '8px',
                      flex: '1 0 0',
                      alignSelf: 'stretch',
                    }}
                    onClick={() => handleMealClick(meal)}
                  >
                    <Box
                      id="meal-name"
                      sx={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'flex-start',
                        gap: '8px',
                        alignSelf: 'stretch',
                      }}
                    >
                      <Typography
                        sx={{
                          display: '-webkit-box',
                          WebkitBoxOrient: 'vertical',
                          WebkitLineClamp: 2,
                          alignSelf: 'stretch',
                          overflow: 'hidden',
                          color: 'var(--Gray-gray12, #171717)',
                          leadingTrim: 'both',
                          textEdge: 'cap',
                          textOverflow: 'ellipsis',
                          fontFamily: 'Montserrat',
                          fontSize: '16px',
                          fontStyle: 'normal',
                          fontWeight: 400,
                          lineHeight: 'normal',
                        }}
                      >
                        {meal.box_name}
                      </Typography>
                    </Box>
                  </Box>
                  <Box
                    id="adjust-quantity"
                    sx={{
                      display: 'flex',
                      width: '94px',
                      justifyContent: 'center',
                      alignItems: 'center',
                      gap: '1px',
                    }}
                  >
                    <Button
                      id="decrement"
                      sx={{
                        color: totalMeals !== maxQuantity ? '#DF230A' : 'var(--Gray-gray12, #171717)',
                        display: 'flex',
                        width: '30px',
                        minWidth: '30px',
                        height: 'var(--2, 28px)',
                        padding: 'var(--0, 0px) var(--2, 7px)',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 'var(--2, 7px)',
                        flexShrink: 0,
                        borderRadius: 'var(--2, 5px) var(--0, 0px) var(--0, 0px) var(--2, 5px)',
                        border:
                          totalMeals == maxQuantity
                            ? 'var(--1, 2px) solid var(--color12, #1C124D)'
                            : 'var(--1, 2px) solid var(--_Tamagui-Red-red11, #CD2B31)',
                        background:
                          totalMeals == maxQuantity ? 'var(--color4, #EBE8F3)' : 'var(--_Tamagui-Red-red4, #FFE5E5)',
                      }}
                      onClick={meal.quantity > 1 ? () => handleDecrement(meal.box_id) : () => handleDelete(meal.box_id)}
                    >
                      {meal.quantity > 1 ? (
                        <RemoveIcon
                          sx={{
                            width: 'var(--_16, 16px)',
                            height: 'var(--_16, 16px)',
                            flexShrink: 0,
                          }}
                        />
                      ) : (
                        <DeleteOutlineIcon
                          sx={{
                            width: 'var(--_16, 16px)',
                            height: 'var(--_16, 16px)',
                            flexShrink: 0,
                          }}
                        />
                      )}
                    </Button>
                    <Box
                      id="current-quantity"
                      sx={{
                        display: 'flex',
                        height: '30px',
                        padding: '7px 12px',
                        flexDirection: 'column',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: '10px',
                        flex: '1 0 0',
                        background: 'var(--color1, #FDFDFD)',
                      }}
                    >
                      <Typography
                        sx={{
                          display: 'flex',
                          width: '18px',
                          height: '20px',
                          flexDirection: 'column',
                          justifyContent: 'center',
                          flexShrink: 0,
                          color: 'var(--color12, #1C124D)',
                          textAlign: 'center',
                          leadingTrim: 'both',
                          textEdge: 'cap',
                          fontFamily: 'Montserrat',
                          fontSize: '16px',
                          fontStyle: 'normal',
                          fontWeight: 700,
                          lineHeight: 'normal',
                        }}
                      >
                        {meal.quantity}
                      </Typography>
                    </Box>
                    <Button
                      id="increment"
                      sx={{
                        color: totalMeals !== maxQuantity ? '#DF230A' : 'var(--Gray-gray12, #171717)',
                        display: 'flex',
                        width: '30px',
                        minWidth: '30px',
                        height: 'var(--2, 28px)',
                        padding: 'var(--0, 0px) var(--2, 7px)',
                        justifyContent: 'center',
                        alignItems: 'center',
                        gap: 'var(--2, 7px)',
                        flexShrink: 0,
                        borderRadius: '0px var(--2, 5px) var(--2, 5px) 0px',
                        border:
                          totalMeals == maxQuantity
                            ? 'var(--1, 2px) solid var(--color12, #1C124D)'
                            : 'var(--1, 2px) solid var(--_Tamagui-Red-red11, #CD2B31)',
                        background:
                          totalMeals == maxQuantity ? 'var(--color4, #EBE8F3)' : 'var(--_Tamagui-Red-red4, #FFE5E5)',
                      }}
                      onClick={() => handleIncrement(meal.box_id)}
                    >
                      <AddIcon
                        sx={{
                          width: 'var(--_16, 16px)',
                          height: 'var(--_16, 16px)',
                          flexShrink: 0,
                        }}
                      />
                    </Button>
                  </Box>
                </Box>
                {/* Add content for the item details here */}
              </Box>
            </Box>
          ))}
        </Box>
      </Box>
      <Button
        sx={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '16px',
          alignSelf: 'stretch',
          borderRadius: 'var(--3, 7px)',
          border: 'var(--1, 2px) solid var(--color12, #1C124D)',
        }}
        onClick={() => setShowMealOptions(true)}
      >
        <AddIcon
          sx={{
            width: 'var(--1, 20px)',
            height: 'var(--1, 20px)',
          }}
        />
        <Typography
          sx={{
            color: 'var(--color12, #1C124D)',
            textAlign: 'center',
            leadingTrim: 'both',
            textEdge: 'cap',
            fontFamily: 'Montserrat',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: 'normal',
          }}
        >
          Add Items
        </Typography>
      </Button>

      <Button
        sx={{
          display: 'flex',
          justifyContent: 'center',
          backgroundColor: '#1C124D',
          alignItems: 'center',
          gap: '16px',
          alignSelf: 'stretch',
          borderRadius: 'var(--3, 7px)',
          border: 'var(--1, 2px) solid var(--color12, #1C124D)',
        }}
        onClick={handleSave}
        disabled={!isTotalValid || !hasChanges}
      >
        <Typography
          sx={{
            color: 'white',
            textAlign: 'center',
            leadingTrim: 'both',
            textEdge: 'cap',
            fontFamily: 'Montserrat',
            fontSize: '14px',
            fontStyle: 'normal',
            fontWeight: 700,
            lineHeight: 'normal',
          }}
        >
          Save Changes
        </Typography>
      </Button>

      {isMobileView ? (
        <Drawer
          anchor="right"
          open={showMealOptions}
          onClose={() => setShowMealOptions(false)}
        >
          <MealOrderOptionsMenu
            order={order}
            onClose={() => setShowMealOptions(false)}
            onAddMeal={handleAddMeal}
          />
        </Drawer>
      ) : (
        <Dialog
          open={showMealOptions}
          onClose={() => setShowMealOptions(false)}
          maxWidth="xs"
          PaperProps={{
            sx: {
              overflow: 'hidden',
            },
          }}
        >
          <MealOrderOptionsMenu
            order={order}
            onClose={() => setShowMealOptions(false)}
            onAddMeal={handleAddMeal}
          />
        </Dialog>
      )}

      {selectedMeal && (
        <Dialog
          open={true}
          onClose={closeMealInfoCard}
          maxWidth="md"
        >
          <MealInfoCard
            mealInfo={selectedMeal}
            order={order}
            meal={selectedMeal}
            handleDecrement={handleDecrement}
            handleIncrement={handleIncrement}
            onClose={closeMealInfoCard}
          />
        </Dialog>
      )}
    </Box>
  );
};

export default OrderDetailsAdjustmentCard;

{
  /* <>
            <Box
                id='order-details-adjustment-card'
                sx={{
                    padding: '16px',
                    borderRadius: '8px',
                    border: '1px solid #E0E0E0',
                    boxShadow: '0px 4px 12px rgba(0, 0, 0, 0.1)',
                    backgroundColor: '#FFFFFF',
                    width: '100%',
                    maxWidth: '400px',
                    margin: 'auto',
                }}
            >
                <Box
                    sx={{
                        display: 'flex',
                        justifyContent: 'space-between',
                        alignItems: 'center',
                        width: '334px',
                        height: '37px',
                        padding: '6px 0px',
                        gap: '8px',
                        opacity: 1,
                        mb: 2,
                    }}
                >
                    <IconButton onClick={onClose} sx={{ color: '#000' }}>
                        <ArrowBackIcon />
                    </IconButton>
                    <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
                        Order Items
                    </Typography>
                    <Typography variant="body1" sx={{ fontWeight: 'bold', color: isTotalValid ? '#000' : '#FF0000' }}>
                        {totalMeals}/14
                    </Typography>
                </Box>
                <Box
                    id='meals-container'
                    sx={{
                        width: '334px',
                        height: '504px', 
                        padding: '0px 16px',
                        gap: '24px',
                        opacity: 1,
                        overflowY: 'auto',
                    }}
                >
                    {meals.map((meal) => (
                        <Box 
                            key={meal.id} 
                            sx={{ 
                                display: 'flex', 
                                alignItems: 'center', 
                                mb: 2,
                                width: '302px',
                                height: '64px',
                                gap: '12px',
                                borderRadius: '8px 0px 0px 0px',
                            }}
                        >
                            <Box sx={{ display: 'flex', alignItems: 'center', width: '60%' }}>
                                <Avatar 
                                    src={`https://loremflickr.com/320/240/food?random=${meal.id}`} 
                                    alt={meal.name} 
                                    sx={{ mr: 2 }} 
                                />
                                <Typography 
                                    variant="body2" 
                                    sx={{ 
                                        fontWeight: 'bold',
                                        overflow: 'hidden',
                                        display: '-webkit-box',
                                        WebkitLineClamp: 2,
                                        WebkitBoxOrient: 'vertical',
                                        pr: 2,
                                        lineHeight: '1.2em',
                                        height: '2.4em'
                                    }}
                                >
                                    {meal.name}
                                </Typography>
                            </Box>
                            <Box 
                                sx={{ 
                                    display: 'flex', 
                                    alignItems: 'center', 
                                    justifyContent: 'flex-end',
                                    width: '40%'
                                }}
                            >
                                <QuantityAdjuster 
                                    quantity={meal.quantity} 
                                    adjustQuantity={(newQuantity) => handleQuantityChange(meal.id, newQuantity)} 
                                    customStyles={{
                                        container: { width: '120px' },
                                        button: { padding: '4px 8px' },
                                        text: { fontSize: '18px' },
                                    }}
                                />
                                <IconButton onClick={() => handleDelete(meal.id)} sx={{ color: '#FF0000' }}>
                                    <DeleteIcon />
                                </IconButton>
                            </Box>
                        </Box>
                    ))}
                </Box>
                <Button 
                    variant="outlined" 
                    onClick={() => setShowMealOptions(true)}
                    sx={{ width: '100%', fontWeight: 'bold', textTransform: 'none', mt: 2, mb: 2 }}
                >
                    + Add Items
                </Button>
                <Button
                    variant="contained"
                    startIcon={<SaveIcon />}
                    disabled={!isTotalValid || !hasChanges}
                    onClick={handleSave}
                    sx={{
                        width: '100%',
                        fontWeight: 'bold',
                        textTransform: 'none',
                        backgroundColor: isTotalValid && hasChanges ? '#4CAF50' : undefined,
                        '&:hover': {
                            backgroundColor: isTotalValid && hasChanges ? '#45a049' : undefined,
                        }
                    }}
                >
                    Save Changes
                </Button>
            </Box>

            <Dialog 
                open={showMealOptions} 
                onClose={() => setShowMealOptions(false)}
                maxWidth="xs"
            >
                <MealOrderOptionsMenu 
                    order={order}
                    onClose={() => setShowMealOptions(false)}
                    onAddMeal={handleAddMeal}
                />
            </Dialog>
        </> */
}
